<template>
	<v-dialog
	  v-model="dialog"
	  @input="$emit('inupt', dialog)"
	  scrollable
	  persistent
	  :overlay="false"
	  max-width="600px"
	  transition="dialog-transition"
	  v-bind="$attrs"
	>
		<template v-slot:activator="{ on }">
			<slot name="activator" v-bind="on"></slot>
		</template>
		
		<v-card>
			<v-card-title primary-title>
				{{ title }}
			</v-card-title>

			<v-card-text>
			 	<slot
			 		v-bind:model="model"
			 	></slot>
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="danger" @click="cancel()">Cancel</v-btn>
				<v-btn text color="primary" @click="confirm()">OK</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			value: {
				type: [Object, Array, String, Number, Boolean],
				default: undefined
			},

			title: {
				type: String,
				default: "Dialog"
			},

			onConfirm: {
				type: Function,
				default: undefined
			},

			onCancel: {
				type: Function,
				default: undefined
			}
		},

		data() {
			return {
				dialog: this.value,
				model: {
					data: undefined
				}
			}
		},

		methods: {
			cancel() {
				this.dialog = false;
				this.$emit('cancel', this.model.data);
				
				if(this.onCancel != undefined) {
					this.onCancel();
				}
			},

			confirm() {
				this.dialog = false;
				this.$emit('confirm', this.model.data);

				if(this.onConfirm != undefined) {
					this.onConfirm(this.model.data);
				}
			}
		}
	}
</script>